export default __webpack_public_path__ + "static/okr-progress-3f0550ca88978cbfc95007c12394daa2.webm";